import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import stickybits from 'stickybits';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopCurrentFilters from '../components/ShopCurrentFilters.js';
import ShopProductListing from '../components/ShopProductListing.js';
import ShopDropdownSort from '../components/ShopDropdownSort.js';

export default class ShopContentOver767 extends Component {
  static propTypes = {
    windowWidth: PropTypes.number.isRequired,
    setSearchValue: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    hasMoreToScroll: PropTypes.bool.isRequired,
    loadMoreScroll: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    usableProducts: PropTypes.array.isRequired,
    visibleProducts: PropTypes.array.isRequired,
    productTypeInfo_DictionaryArray: PropTypes.array.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    toggleProductCategory: PropTypes.func.isRequired,
    togglePureMaple: PropTypes.func.isRequired,
    toggleExtraValue: PropTypes.func.isRequired,
    toggleNonMaple: PropTypes.func.isRequired,
    pureMapleCheck: PropTypes.func.isRequired,
    extraValueCheck: PropTypes.func.isRequired,
    nonMapleCheck: PropTypes.func.isRequired,
    pureSyrupCheck: PropTypes.func.isRequired,
    pureCreamCheck: PropTypes.func.isRequired,
    pureCandyCheck: PropTypes.func.isRequired,
    pureSugarCheck: PropTypes.func.isRequired,
    extraSaucesCheck: PropTypes.func.isRequired,
    extraBeveragesCheck: PropTypes.func.isRequired,
    extraCandyCheck: PropTypes.func.isRequired,
    extraJellyCheck: PropTypes.func.isRequired,
    extraGiftSetsCheck: PropTypes.func.isRequired,
    nonPancakeMixesCheck: PropTypes.func.isRequired,
    nonInformationalCheck: PropTypes.func.isRequired,
    nonClothesCheck: PropTypes.func.isRequired,
    nonCandlesCheck: PropTypes.func.isRequired,
    nonKitchenwareCheck: PropTypes.func.isRequired,
    nonBooksCheck: PropTypes.func.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    addItemToCart: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired,
    dropdownSort: PropTypes.func.isRequired,
    selectDropdownItem: PropTypes.func.isRequired,
    toggleDropdownOpen: PropTypes.func.isRequired,
    dropdownOpen: PropTypes.bool.isRequired,
    dropdownValue: PropTypes.string.isRequired,
    scrollToTop: PropTypes.func.isRequired,
    showScrollUpButton: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    stickybits("#scrollToTopButtonID", {verticalPosition: "bottom"});
  }

  render() {

    const ShopFilterDisplay_Over767 = ( 
      <ShopFilterDisplay_Over767_Div id="shopFilterID">
            <SectionDiv>
              <h2>Product Category</h2>
              <Container>
                    <Label check >
                       <Input type="checkbox" 
                        checked={this.props.checked_pureMapleProducts} 
                        onClick={ this.props.pureMapleCheck } /> {' '}
                       <p>Pure Maple</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraValueProducts} 
                        onClick = { this.props.extraValueCheck } /> {' '}
                       <p>Extra Value</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonMapleProducts} 
                        onClick = { this.props.nonMapleCheck } /> {' '}
                       <p>Non Maple</p>
                     </Label>
              </Container>
            </SectionDiv>
            
            {/* ************** Pure Maple Filter Section ************** */}
            <SectionDiv>
              <h2>Pure Maple Products</h2>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_pureSyrup} 
                        onClick = { this.props.pureSyrupCheck } /> {' '}
                       <p>Syrup</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_pureCream} 
                        onClick = { this.props.pureCreamCheck } /> {' '}
                       <p>Cream</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_pureCandy} 
                        onClick = { this.props.pureCandyCheck } /> {' '}
                       <p>Candy</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_pureSugar} 
                        onClick = { this.props.pureSugarCheck } /> {' '}
                       <p>Sugar</p>
                     </Label>
              </Container>
            </SectionDiv>


            {/* ************** Extra Value Filter Section ************** */}
            <SectionDiv>
              <h2>Extra Value Products</h2>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraSauces} 
                        onClick = { this.props.extraSaucesCheck } /> {' '}
                       <p>Sauces</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraBeverages} 
                        onClick = { this.props.extraBeveragesCheck } /> {' '}
                       <p>Beverages</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraCandy} 
                        onClick = { this.props.extraCandyCheck } /> {' '}
                       <p>Candy</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraJelly} 
                        onClick = { this.props.extraJellyCheck } /> {' '}
                       <p>Jelly</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_extraGiftSets} 
                        onClick = { this.props.extraGiftSetsCheck } /> {' '}
                       <p>Gift Sets</p>
                     </Label>
              </Container>
            </SectionDiv>


            {/* ************** Non Maple Filter Section ************** */}
            <SectionDiv>
              <h2>Non Maple Products</h2>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonPancakeMixes} 
                        onClick = { this.props.nonPancakeMixesCheck } /> {' '}
                       <p>Pancake Mixes</p>
                     </Label>
              </Container>
              {/*
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonInformational} 
                        onClick = { this.props.nonInformationalCheck } /> {' '}
                       <p>Informational</p>
                     </Label>
              </Container>
            */}
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonClothes} 
                        onClick = { this.props.nonClothesCheck } /> {' '}
                       <p>Clothes</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonCandles} 
                        onClick = { this.props.nonCandlesCheck } /> {' '}
                       <p>Candles</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonKitchenware} 
                        onClick = { this.props.nonKitchenwareCheck } /> {' '}
                       <p>Kitchenware</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_nonBooks} 
                        onClick = { this.props.nonBooksCheck } /> {' '}
                       <p>Books</p>
                     </Label>
              </Container>

            </SectionDiv>

            {this.props.showScrollUpButton ?
              <ScrollToTopImage id="scrollToTopButtonID" onClick={this.props.scrollToTop} 
              src={require("../media/scrollUpArrow2.png")}></ScrollToTopImage>
            :
            "" }

      </ShopFilterDisplay_Over767_Div>
    );

    const ShopContainer_Over767 = (
      <Container_Over767>
        {ShopFilterDisplay_Over767}
        
        <ContainerDiv_RightSide>
          <SearchFilterHeading>
            <div>
              <h1>Shop Patterson Farms</h1> 
              
              {/*<DivSpecial><p><b>FREE</b> bag of maple crunchies (a $9.50 value!) for every $25.00 spent! <i>Sale ends June 30th, 2020.</i></p></DivSpecial>*/}
            
            </div>
          </SearchFilterHeading>

          <hr />

          <ShopFilterSearchTextbox toggleFilter={this.props.toggleFilter} windowWidth={this.props.windowWidth}
            setSearchValue={this.props.setSearchValue} searchValue={this.props.searchValue} />
          <ShopCurrentFilters {...this.props} usableProductsCount={this.props.usableProducts.length} />
          <ShopDropdownSort selectDropdownItem={this.props.selectDropdownItem} toggleDropdownOpen={this.props.toggleDropdownOpen}
                            dropdownOpen={this.props.dropdownOpen} dropdownValue={this.props.dropdownValue} />
          <ShopProductListing products={this.props.products} usableProducts={this.props.usableProducts} visibleProducts={this.props.visibleProducts}
              hasMoreToScroll={this.props.hasMoreToScroll} loadMoreScroll={this.props.loadMoreScroll} 
              addItemToCart={this.props.addItemToCart} addItemToCartState={this.props.addItemToCartState} />

        </ContainerDiv_RightSide>

      </Container_Over767>
    );

    return (
      <FluidContainer className="p-0" fluid>
          
          {ShopContainer_Over767}

      </FluidContainer>
    );
  }
}

const DivSpecial = styled.div``;

const ScrollToTopImage = styled.img`
  width: 50px; 
  height: 50px;
  background: transparent;
  color: white;
  bottom: 0;
  display: block!important;
  margin: 0 auto;
  padding: 0!important;
  position: fixed;
  cursor: pointer;
  margin-left: 45px;
`;

const FluidContainer = styled(Container)`  `;
const InternalContainer = styled(Container)`  `;

const SectionDiv = styled.div`
  margin: 0 0 30px 0;
  
  // If you highlight a filter, bold the text
  .container { label { :hover { p { font-weight: bold!important; } } } }
`;

const Container_Over767 = styled(Container)`
  padding: 0 5px 0 px!important;
  width: 100%!important;
  max-width: 1400px!important;
  display: flex;
`;

const ContainerDiv_RightSide = styled.div` 
  width: 100%; 
  hr { 
    border-top: 1px solid rgba(0,0,0,.1);
    margin: 16px 0 16px 0;
  }
`;

const SearchFilterHeading = styled.div`
  div { text-align: left; }

  /*
  p:nth-of-type(1) {
    margin: 0;
    font-size: 26px!important;
    display: inline-block;
  }

  ${media.xl`  p:nth-of-type(1) { font-size: 30px!important; } `}
  ${media.xxl`  p:nth-of-type(1) { font-size: 36px!important; } `}
  */
`;

const ShopFilterDisplay_Over767_Div = styled.div`
  width: 22%;
  max-width: 180px;
  margin-right: 20px;
  
  h2 {
    text-align: left;
    font-size: 14px;
    margin: 10px 0 0px 0;
    color: #822D08!important;
    ${media.lg`  font-size: 16px; `}

  }

  .container {
    padding: 0!important;
    margin: 0!important;
    width: 100%!important;
    height: 30px;

    :focus {
      outline: none;
    }

    label {
      height: 100%;
      min-width: 100%;
      width: 100%;
      line-height: 40px;
      margin: 0;
      padding: 0;
      display: inline-flex;

      input {
        width: 18px;
        height: 18px;
        margin: 11px 0 0 0;
        position: relative;
      }

      p {
        width: calc(100% - 18px);
        margin: 0 0 0 10px;
        text-align: left;
        font-size: 14px!important;

        ${media.lg`font-size: 16px!important;`}
      }

    }
  }



`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopContentOver767.js